<template>
  <tr>
    <td class="text-xs-left live-messages__data-table--published-date">
      {{ item.publicationDate | formatDate }}
    </td>
    <td class="text-xs-left live-messages__data-table--text">
      <v-tooltip bottom>
      <span slot="activator">
        {{
          item.title
          || getSimpleStringFromQuillText(item.body)
          || 'Tipo: ' + $t(`message.block.form.liveMessage.types.${item.type}`)
        }}
      </span>
        <span>
        {{
            item.title
            || getSimpleStringFromQuillText(item.body)
            || $t(`message.block.form.liveMessage.types.${item.type}`)
          }}
      </span>
      </v-tooltip>
    </td>
    <td class="text-xs-left live-messages__data-table--published"
        v-html="$t(`message.content.status.${item.published ? 'published' : 'unpublished'}`)"
    ></td>
    <td class="live-messages__data-table--actions align-end layout px-0">
      <v-btn flat icon color="primary">
        <v-icon @click="$emit('edit')">edit</v-icon>
      </v-btn>
      <v-btn flat icon :class="{'state--unpublished': item.published}" color="primary">
        <v-icon @click="$emit('publish')">publish</v-icon>
      </v-btn>
      <v-btn flat icon color="primary">
        <v-icon @click="$emit('delete')">delete</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>

export default {
  name: 'nx-live-messages-data-table-row',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /**
     * Cleans Quill data to display a simple text in the view
     */
    getSimpleStringFromQuillText(text) {
      let simpleText = '';
      Array.from(text).forEach((e) => {
        if (typeof e.insert === 'object') {
          simpleText += this.$t(`message.content.live.embed.${Object.keys(e.insert)[0]}`);
        } else {
          simpleText += e.insert;
        }
      });
      const trimmedText = simpleText.replace('\n', '').replace('\r', '');
      if (!trimmedText.length) {
        return false;
      }
      return trimmedText;
    },
  },
};
</script>
